var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"return-text"},[_vm._v(_vm._s(_vm.$t('退')))])}
var staticRenderFns = []

export { render, staticRenderFns }